import React from "react";
import { useCustomerStore } from "../../../Store/Customer";
import CustomerBasicDetailsCard from "./CustomerBasicDetailsCard";
import CustomerToggelables from "./CustomerToggelables";
import CustomerAllowedPaymentMethodsCard from "./CustomerAllowedPaymentMethodsCard";
import CustomerAvailablePaymentMethodsCard from "./CustomerAvailablePaymentMethodsCard";
import CustomerClientPortalCard from "./CustomerClientPortalCard";
import CustomerTransactionsCard from "./CustomerTransactionsCard";
import CustomerEmailRecipientsCard from "./CustomerEmailRecipientsCard";
import { useAuth0 } from "@auth0/auth0-react";
import { useSettingsStore } from "../../../Store/Settings";

const CustomerDetailRightCardArray: React.FC = () => {
  const { isLoading, customerDetailEntity, editCustomerDetails } = useCustomerStore();
  const { settings } = useSettingsStore();
  const { getAccessTokenSilently } = useAuth0();

  const onChange = async (
    key: "reminder_enabled_date" | "auto_collection_enabled_date",
    value: boolean
  ) => {
    if (key === "reminder_enabled_date" && !value) {
      customerDetailEntity &&
        (await editCustomerDetails(getAccessTokenSilently, customerDetailEntity.id.toString(), {
          reminder_enabled_date: null,
          auto_collection_enabled_date: null
        }));
    } else {
      customerDetailEntity?.id &&
        (await editCustomerDetails(getAccessTokenSilently, customerDetailEntity.id.toString(), {
          [key]: value ? new Date() : null
        }));
    }
  };

  const customFieldsFilterEnabled = settings?.payment_custom_field_filter_enabled || false;

  return (
    <div className="col-span-1 flex flex-col h-[calc(100vh-9rem)] overflow-y-auto">
      <CustomerBasicDetailsCard />
      <CustomerToggelables
        labelText="Enable Invoice Emails"
        checkedValue={!!customerDetailEntity?.reminder_enabled_date}
        onChangeHandler={checked => onChange("reminder_enabled_date", checked)}
        isLoading={isLoading}
        description="Once activated, Zomentum will take care of sending open invoices directly to the client. Reminder emails will be sent as long as the invoice remains unpaid."
      />

      <CustomerToggelables
        labelText={customFieldsFilterEnabled ? "Allow Auto Collect" : "Enable Auto Collect"}
        checkedValue={!!customerDetailEntity?.auto_collection_enabled_date}
        onChangeHandler={checked => onChange("auto_collection_enabled_date", checked)}
        isLoading={isLoading}
        description="If one or more payment methods are on file for this customer, we will automatically collect the payments for open invoices."
        disabled={!customerDetailEntity?.reminder_enabled_date}
      />
      <CustomerAllowedPaymentMethodsCard />
      <CustomerAvailablePaymentMethodsCard />
      <CustomerEmailRecipientsCard />
      <CustomerClientPortalCard />
      <CustomerTransactionsCard />
    </div>
  );
};

export default CustomerDetailRightCardArray;
